// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3W-18","label":"Labeled_label__1O6LT","divider":"Labeled_divider__3meYf"};